/* =====================================================================
   On-Tec Store - FitCamX Fahrzeug-Finder
   Filterlogik nach fitcamx-filter-logik.md
   Konfiguration kommt ueber data-Attribute am Wurzelelement .fcx:
     data-collection  Handle der Kollektion
     data-mail        E-Mail fuer Passform-Anfragen
     data-contact     Link zur Beratungsseite
   ===================================================================== */
function fcxInit(ROOT){
  if (!ROOT || ROOT.dataset.fcxReady === '1') return;
  ROOT.dataset.fcxReady = '1';
  
  // Sentinel fuer "modelluebergreifend" (siehe unten)
  var UNI       = 'Alle Modelle';
  var UNI_LABEL = 'Alle Modelle (modellübergreifend)';

  var HANDLE = ROOT.dataset.collection;
  var MAIL   = ROOT.dataset.mail || '';
  var CONTACT_URL = ROOT.dataset.contact || '/pages/kontakt';

  /* ---------------------------------------------------------------
     Baureihen-Referenz (Section-Einstellung "Baureihen-Referenz").
     Eine Zeile je Baureihe:  Marke | Modell | Code/Code | von-bis
     z.B.  BMW | 3er | F30/F31/F34 | 2012-2019
     Dient dazu, Baureihen auch dann waehlbar zu machen, wenn es fuer
     sie (noch) kein modellspezifisches Produkt gibt - z.B. damit ein
     F30-Fahrer die markenweite "BMW F Chassis"-Kamera findet.
  --------------------------------------------------------------- */
  var REF = [];
  (function(){
    var n = ROOT.querySelector('script[data-fcx-ref]');
    if (!n) return;
    var txt = '';
    try { txt = JSON.parse(n.textContent || '""') || ''; } catch(e){ txt = ''; }
    String(txt).split(/\r?\n/).forEach(function(line){
      var c = line.split('|').map(function(s){ return s.trim(); });
      if (c.length < 3 || !c[0] || !c[1] || !c[2] || c[0].charAt(0) === '#') return;
      var codes = c[2].split(/[\/,\s]+/).filter(Boolean);
      var m = (c[3] || '').match(/((?:19|20)\d{2})\s*-\s*((?:19|20)\d{2})?/);
      REF.push({ marke:c[0], modell:c[1], codes:codes,
                 from: m ? parseInt(m[1],10) : null,
                 to:   m ? (m[2] ? parseInt(m[2],10) : new Date().getFullYear()) : null });
    });
  })();

  /* ---------------------------------------------------------------
     Tag-Helfer. Alles wird ausschliesslich aus Produkt-Tags gelesen.
     Mehrfachbelegung ist gewollt: ein Produkt kann mehrere
     marke:/modell:/bj:-Tags tragen und in mehreren Filterpfaden liegen.
  --------------------------------------------------------------- */
  function vals(p, prefix){
    var out = [], pl = prefix + ':';
    for (var i = 0; i < p.tg.length; i++){
      var t = p.tg[i];
      if (t.toLowerCase().indexOf(pl) === 0){
        var v = t.slice(pl.length).trim();
        if (v) out.push(v);
      }
    }
    return out;
  }
  function has(list, v){
    if (!v) return false;
    var lv = v.toLowerCase();
    for (var i = 0; i < list.length; i++){ if (list[i].toLowerCase() === lv) return true; }
    return false;
  }
  function passform(p){ var v = vals(p, 'passform'); return v.length ? v[0].toLowerCase() : 'modellspezifisch'; }
  function isAsk(p){ var pf = passform(p); return pf === 'rueckfrage' || pf === 'rückfrage'; }
  // Modelluebergreifend: passform:markenweit ODER Tag modell:Alle Modelle.
  // Diese Produkte gelten fuer die ganze Marke und erscheinen deshalb IMMER
  // im Hauptblock - unabhaengig von Modell- und Baujahr-Auswahl.
  function isUniversal(p){
    if (isAsk(p)) return false;
    if (passform(p) === 'markenweit') return true;
    return has(vals(p, 'modell'), UNI);
  }
  function coversAllYears(p){ return has(vals(p, 'bj'), 'alle'); }
  function numYears(p){
    return vals(p,'bj').map(function(y){ return parseInt(y,10); }).filter(function(y){ return !isNaN(y); });
  }
  // gen:<Modell>:<Code>  ->  Codes des Produkts fuer genau dieses Modell
  function genCodes(p, modell){
    var out = [];
    vals(p,'gen').forEach(function(v){
      var i = v.lastIndexOf(':');
      if (i < 1) return;
      if (modell && v.slice(0,i).trim().toLowerCase() !== modell.toLowerCase()) return;
      out.push(v.slice(i+1).trim());
    });
    return out;
  }
  // serie:<Familie>  ->  markenweites Produkt gilt nur fuer diese Baureihen-Familie (z.B. BMW F)
  function series(p){ return vals(p,'serie'); }
  function famMatch(codes, fams){
    for (var i = 0; i < codes.length; i++)
      for (var j = 0; j < fams.length; j++)
        if (codes[i].toUpperCase().indexOf(fams[j].toUpperCase()) === 0) return true;
    return false;
  }
  function intersects(a, b){
    for (var i = 0; i < a.length; i++) if (has(b, a[i])) return true;
    return false;
  }

  function uniqSorted(arr, numericDesc){
    var seen = {}, out = [];
    for (var i = 0; i < arr.length; i++){
      var k = arr[i].toLowerCase();
      if (!seen[k]){ seen[k] = 1; out.push(arr[i]); }
    }
    if (numericDesc){
      out.sort(function(a,b){
        var na = parseInt(a,10), nb = parseInt(b,10);
        if (!isNaN(na) && !isNaN(nb)) return nb - na;
        return String(a).localeCompare(String(b), 'de');
      });
    } else {
      out.sort(function(a,b){ return String(a).localeCompare(String(b), 'de', {numeric:true, sensitivity:'base'}); });
    }
    return out;
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* --------------------------- State --------------------------- */
  var PRODUCTS = [];
  var state = { marke:'', modell:'', gen:'', bj:'', chips:[] };

  var $   = function(n){ return ROOT.querySelector('[data-fcx="'+n+'"]'); };
  var selM = ROOT.querySelector('[data-sel="marke"]');
  var selMo= ROOT.querySelector('[data-sel="modell"]');
  var selB = ROOT.querySelector('[data-sel="bj"]');
  var steps= ROOT.querySelectorAll('.fcx-step');

  /* ------------------- Dropdown-Datenquellen -------------------
     Schritt 1: alle distinct marke:-Werte
     Schritt 2: "Alle Modelle (modelluebergreifend)" als erste Option, sofern
                die Marke modelluebergreifende Produkte hat, danach alle
                distinct modell:-Werte der gewaehlten Marke
     Schritt 3: alle distinct bj:-Werte der gefilterten Produkte,
                absteigend; "alle" wird NICHT als Option angezeigt
  --------------------------------------------------------------- */
  function allBrands(){
    var a = [];
    PRODUCTS.forEach(function(p){ a = a.concat(vals(p, 'marke')); });
    return uniqSorted(a);
  }
  // Hat die Marke modelluebergreifende Produkte?
  function hasUniversal(marke){
    for (var i = 0; i < PRODUCTS.length; i++){
      var p = PRODUCTS[i];
      if (has(vals(p,'marke'), marke) && isUniversal(p)) return true;
    }
    return false;
  }
  // Reine Modellnamen (ohne den Sentinel).
  function modelsFor(marke){
    var a = [];
    PRODUCTS.forEach(function(p){
      if (!has(vals(p,'marke'), marke)) return;
      if (isUniversal(p)) return;
      vals(p,'modell').forEach(function(m){ if (m.toLowerCase() !== UNI.toLowerCase()) a.push(m); });
    });
    return uniqSorted(a);
  }
  // Auswahlliste des Modell-Dropdowns: modelluebergreifend zuerst, dann Modelle.
  function modelOptions(marke){
    var list = modelsFor(marke);
    if (hasUniversal(marke)) list = [UNI].concat(list);
    return list;
  }
  function isUniSelected(){ return !!state.modell && state.modell.toLowerCase() === UNI.toLowerCase(); }

  /* ------------------- Baureihen je Modell ---------------------
     Quelle 1: Referenztabelle (REF)
     Quelle 2: gen:-Tags der Produkte, die in keiner REF-Zeile stehen.
               Codes, die immer gemeinsam auf denselben Produkten stehen,
               werden zu einer Baureihe zusammengefasst.
     Ergebnis: [{key, codes[], from, to}] - neueste zuerst
  --------------------------------------------------------------- */
  var GEN_CACHE = {};
  function genEntries(marke, modell){
    if (!marke || !modell || modell.toLowerCase() === UNI.toLowerCase()) return [];
    var ck = (marke + '|' + modell).toLowerCase();
    if (GEN_CACHE[ck]) return GEN_CACHE[ck];
    var list = [];
    REF.forEach(function(r){
      if (r.marke.toLowerCase() === marke.toLowerCase() && r.modell.toLowerCase() === modell.toLowerCase())
        list.push({ codes:r.codes.slice(), from:r.from, to:r.to });
    });
    var known = function(c){ for (var i=0;i<list.length;i++) if (has(list[i].codes, c)) return true; return false; };
    var sig = {}, years = {};
    PRODUCTS.forEach(function(p, idx){
      if (!has(vals(p,'marke'), marke) || !has(vals(p,'modell'), modell) || isUniversal(p)) return;
      genCodes(p, modell).forEach(function(c){
        if (known(c)) return;
        var k = c.toUpperCase();
        sig[k] = (sig[k] || '') + idx + ',';
        years[k] = (years[k] || []).concat(numYears(p));
        sig[k + '#'] = c;
      });
    });
    var groups = {};
    Object.keys(sig).forEach(function(k){
      if (k.slice(-1) === '#') return;
      var g = groups[sig[k]] || (groups[sig[k]] = { codes:[], ys:[] });
      g.codes.push(sig[k + '#']); g.ys = g.ys.concat(years[k]);
    });
    Object.keys(groups).forEach(function(s){
      var g = groups[s];
      list.push({ codes:g.codes, from: g.ys.length ? Math.min.apply(null,g.ys) : null,
                  to: g.ys.length ? Math.max.apply(null,g.ys) : null });
    });
    list.forEach(function(e){ e.key = e.codes.join('/'); });
    list.sort(function(a,b){ return (b.from || 0) - (a.from || 0) || a.key.localeCompare(b.key); });
    GEN_CACHE[ck] = list;
    return list;
  }
  function genByKey(key){
    var l = genEntries(state.marke, state.modell);
    for (var i = 0; i < l.length; i++) if (l[i].key.toLowerCase() === String(key).toLowerCase()) return l[i];
    return null;
  }
  function spanTxt(e){
    if (!e.from) return '';
    return e.from === e.to ? String(e.from) : e.from + '–' + e.to;
  }

  // Baujahre: aus Produkten UND aus der Referenz, damit auch Jahre ohne
  // eigenes Produkt waehlbar sind (dort greifen dann markenweite Produkte).
  function yearsFor(marke, modell){
    if (!modell || modell.toLowerCase() === UNI.toLowerCase()) return [];
    var a = [];
    PRODUCTS.forEach(function(p){
      if (!has(vals(p,'marke'), marke)) return;
      if (!has(vals(p,'modell'), modell)) return;
      if (isUniversal(p) || isAsk(p)) return;
      numYears(p).forEach(function(y){ a.push(String(y)); });
    });
    genEntries(marke, modell).forEach(function(e){
      if (!e.from || !e.to) return;
      for (var y = e.from; y <= e.to; y++) a.push(String(y));
    });
    return uniqSorted(a, true);
  }

  // Passt ein serie-gebundenes markenweites Produkt zur aktuellen Auswahl?
  // Unbekannt (keine Baureihen-Info) = anzeigen, um nichts zu verschlucken.
  function serieFits(p){
    var fams = series(p);
    if (!fams.length) return true;
    if (!state.modell || isUniSelected()) return true;
    var e = state.gen ? genByKey(state.gen) : null;
    if (e) return famMatch(e.codes, fams);
    var list = genEntries(state.marke, state.modell);
    if (state.bj){
      var y = parseInt(state.bj,10);
      list = list.filter(function(x){ return x.from && x.from <= y && y <= x.to; });
    }
    if (!list.length) return true;
    for (var i = 0; i < list.length; i++) if (famMatch(list[i].codes, fams)) return true;
    return false;
  }

  // Modellspezifisches Produkt gegen die gewaehlte Baureihe pruefen.
  function genFits(p, e){
    var pc = genCodes(p, state.modell);
    if (pc.length) return intersects(pc, e.codes);
    if (coversAllYears(p) || !e.from) return true;
    var ys = numYears(p);
    for (var i = 0; i < ys.length; i++) if (ys[i] >= e.from && ys[i] <= e.to) return true;
    return false;
  }

  /* ---------------------- Ergebnislogik ------------------------ */
  // Block 1 - "Passend fuer Ihr Fahrzeug".
  // Enthaelt sowohl die modellspezifischen Treffer (marke + modell + bj) als
  // auch ALLE modelluebergreifenden Produkte der Marke. Modelluebergreifende
  // Produkte werden nie ausgefiltert, solange die Marke passt - sie erscheinen
  // damit immer direkt bei den passenden Dashcams.
  // Nur passform:rueckfrage bleibt separat (Block 2).
  function block1(){
    if (!state.marke) return [];
    var uni = isUniSelected();
    var ge  = state.gen ? genByKey(state.gen) : null;
    var out = PRODUCTS.filter(function(p){
      if (isAsk(p)) return false;
      if (!has(vals(p,'marke'), state.marke)) return false;
      if (isUniversal(p)) return serieFits(p) && chipMatch(p);
      if (uni) return false;
      if (state.modell && !has(vals(p,'modell'), state.modell)) return false;
      if (ge && !genFits(p, ge)) return false;
      if (state.bj && !has(vals(p,'bj'), state.bj) && !coversAllYears(p)) return false;
      return chipMatch(p);
    });
    // Modellspezifische Treffer zuerst, modelluebergreifende danach.
    out.sort(function(a,b){
      var ua = isUniversal(a) ? 1 : 0, ub = isUniversal(b) ? 1 : 0;
      if (ua !== ub) return ua - ub;
      return String(a.t).localeCompare(String(b.t), 'de', {numeric:true, sensitivity:'base'});
    });
    return out;
  }
  // Block 2 - nur noch Produkte mit passform:rueckfrage ("Passform anfragen").
  function block2(){
    if (!state.marke) return [];
    return PRODUCTS.filter(function(p){
      if (!isAsk(p)) return false;
      if (!has(vals(p,'marke'), state.marke)) return false;
      return chipMatch(p);
    });
  }

  /* -------- Sekundaerfilter (optional, aus kanal:/funktion:) ---- */
  function chipValues(p){ return vals(p,'kanal').concat(vals(p,'funktion')); }
  function chipMatch(p){
    if (!state.chips.length) return true;
    var cv = chipValues(p);
    for (var i = 0; i < state.chips.length; i++){ if (!has(cv, state.chips[i])) return false; }
    return true;
  }
  function availableChips(){
    if (!state.marke) return [];
    var a = [];
    PRODUCTS.forEach(function(p){
      if (!has(vals(p,'marke'), state.marke)) return;
      a = a.concat(chipValues(p));
    });
    return uniqSorted(a);
  }

  /* --------------------------- Karte --------------------------- */
  function card(p){
    var marke  = vals(p,'marke')[0] || '';
    var modelle= vals(p,'modell').filter(function(m){ return m.toLowerCase() !== 'alle modelle'; });
    var jahre  = vals(p,'bj').filter(function(y){ return y.toLowerCase() !== 'alle'; });
    var ask    = isAsk(p);
    var lenk   = vals(p,'lenkung')[0] || '';

    var uni    = isUniversal(p);

    var fams   = series(p);
    var fit;
    if (ask){
      fit = 'Passform bitte vor Bestellung anfragen';
    } else if (uni && fams.length){
      fit = 'Passt auf ' + marke + '-Modelle der ' + fams.join('/') + '-Baureihen';
    } else if (uni){
      fit = 'Passt modellübergreifend auf viele Modelle von ' + marke;
    } else {
      var m = state.modell || modelle[0] || marke;
      var gTxt = '';
      var gc = genCodes(p, state.modell || modelle[0] || '');
      if (gc.length) gTxt = ' · ' + gc.join(' / ');
      var yTxt = '';
      if (coversAllYears(p)) {
        yTxt = ' · alle Baujahre';
      } else if (state.bj && has(vals(p,'bj'), state.bj)) {
        yTxt = ' · ' + state.bj;
      } else if (jahre.length) {
        var n = jahre.map(function(x){ return parseInt(x,10); }).filter(function(x){ return !isNaN(x); });
        if (n.length) { var lo = Math.min.apply(null,n), hi = Math.max.apply(null,n);
          yTxt = ' · ' + (lo === hi ? lo : lo + '–' + hi); }
      }
      fit = 'Passt für ' + m + gTxt + yTxt;
    }

    var badges = '';
    if (p.c) badges += '<span class="fcx-badge sale">Angebot</span>';
    if (uni && fams.length) badges += '<span class="fcx-badge uni">' + esc(fams.join('/')) + '-Baureihen</span>';
    else if (uni) badges += '<span class="fcx-badge uni">Modellübergreifend</span>';
    if (ask) badges += '<span class="fcx-badge ask">Passform anfragen</span>';

    var img = p.i
      ? '<img src="'+esc(p.i)+'" alt="'+esc(p.t)+'" loading="lazy" width="300" height="300">'
      : '<span class="noimg">'+esc(p.t)+'</span>';

    return '<a class="fcx-card" href="'+esc(p.u)+'">'
      + '<div class="ph"><div class="pbadges">'+badges+'</div>'+img+'</div>'
      + '<div class="pbody">'
      +   '<div class="pbrand">'+esc(marke)+'</div>'
      +   '<div class="ptitle">'+esc(p.t)+'</div>'
      +   '<div class="fcx-fitline'+(ask ? ' ask' : '')+'">'
      +     '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true">'
      +     (ask ? '<circle cx="12" cy="12" r="9"/><path d="M12 16v-5M12 8h.01"/>' : '<path d="m5 13 4 4L19 7"/>')
      +     '</svg>'+esc(fit)+'</div>'
      +   (lenk ? '<div class="fcx-fitline"><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4 4L19 7"/></svg>'+esc(lenk)+'</div>' : '')
      +   '<div class="prow"><div class="fcx-price">'+esc(p.p)
      +     (p.c ? '<span class="was">'+esc(p.c)+'</span>' : '')+'</div>'
      +     '<span class="fcx-stock'+(p.a ? '' : ' out')+'">'+(p.a ? 'Lieferbar' : 'Ausverkauft')+'</span>'
      +   '</div>'
      + '</div></a>';
  }

  /* --------------------------- Render -------------------------- */
  function fill(sel, list, placeholder, current){
    var html = '<option value="">'+esc(placeholder)+'</option>';
    for (var i = 0; i < list.length; i++){
      var v = list[i];
      var label = (String(v).toLowerCase() === UNI.toLowerCase()) ? UNI_LABEL : v;
      html += '<option value="'+esc(v)+'">'+esc(label)+'</option>';
    }
    sel.innerHTML = html;
    sel.value = current || '';
    if (sel.value !== (current || '')) sel.value = '';
  }

  // Trefferzahl fuer eine hypothetische Auswahl in Schritt 3
  function countFor(gen, bj){
    var g0 = state.gen, b0 = state.bj;
    state.gen = gen || ''; state.bj = bj || '';
    var n = block1().length + block2().length;
    state.gen = g0; state.bj = b0;
    return n;
  }
  function cnt(n){ return n ? ' (' + n + ')' : ' – auf Anfrage'; }

  /* Schritt 3: EIN Dropdown mit zwei Gruppen
       ""            -> Alle Baujahre / Baureihen anzeigen (Standard)
       "g:<Key>"     -> Baureihe (z.B. G20/G21 · 2019–2026)
       "y:<Jahr>"    -> einzelnes Baujahr
     Hinter jeder Option steht die Trefferzahl, damit der Kunde sieht,
     wo es passende Dashcams gibt - inkl. baujahruebergreifender Produkte. */
  function fillStep3(){
    var gens  = genEntries(state.marke, state.modell);
    var years = yearsFor(state.marke, state.modell);
    var cur   = state.gen ? 'g:' + state.gen : (state.bj ? 'y:' + state.bj : '');
    var html;
    if (!state.modell){
      html = '<option value="">Erst Modell wählen</option>';
    } else if (isUniSelected()){
      html = '<option value="">Alle Baujahre (modellübergreifend)</option>';
    } else {
      html = '<option value="">Alle Baujahre &amp; Baureihen' + cnt(countFor('', '')) + '</option>';
      if (gens.length){
        html += '<optgroup label="Nach Baureihe / Generation">';
        gens.forEach(function(e){
          var s = spanTxt(e);
          html += '<option value="g:' + esc(e.key) + '">' + esc(e.codes.join(' / ')) + (s ? ' · ' + s : '') + cnt(countFor(e.key, '')) + '</option>';
        });
        html += '</optgroup>';
      }
      if (years.length){
        html += '<optgroup label="Nach Baujahr">';
        years.forEach(function(y){
          html += '<option value="y:' + esc(y) + '">' + esc(y) + cnt(countFor('', y)) + '</option>';
        });
        html += '</optgroup>';
      }
    }
    selB.innerHTML = html;
    selB.value = cur;
    if (selB.value !== cur){ selB.value = ''; state.gen = ''; state.bj = ''; }
    selB.disabled = !state.modell || isUniSelected() || (!gens.length && !years.length);
  }

  function render(){
    var brands = allBrands();
    fill(selM, brands, 'Marke wählen', state.marke);

    var models = state.marke ? modelOptions(state.marke) : [];
    fill(selMo, models, state.marke ? (models.length ? 'Modell wählen' : 'Keine Modelle hinterlegt') : 'Erst Marke wählen', state.modell);
    selMo.disabled = !state.marke || models.length === 0;
    if (selMo.disabled) state.modell = '';

    fillStep3();
    var sel3 = state.gen || state.bj;

    steps[0].className = 'fcx-step' + (state.marke ? ' done' : '');
    steps[1].className = 'fcx-step' + (state.marke ? (state.modell ? ' done' : '') : ' off');
    steps[2].className = 'fcx-step' + (state.modell ? (sel3 ? ' done' : '') : ' off');

    // Marken-Schnellwahl
    $('brandchips').innerHTML = brands.length
      ? '<span class="bl">Marke schnell wählen</span>' + brands.slice(0, 12).map(function(b){
          return '<button type="button" data-brand="'+esc(b)+'"'+(state.marke.toLowerCase() === b.toLowerCase() ? ' class="active"' : '')+'>'+esc(b)+'</button>';
        }).join('')
      : '';

    // Sekundaerfilter-Chips (nur wenn kanal:/funktion:-Tags existieren)
    var chips = availableChips();
    var sec = $('secondary');
    if (chips.length){
      sec.hidden = false;
      sec.innerHTML = '<span class="bl">Weiter eingrenzen</span>' + chips.map(function(c){
        return '<button type="button" data-chip="'+esc(c)+'"'+(has(state.chips, c) ? ' class="active"' : '')+'>'+esc(c)+'</button>';
      }).join('');
    } else { sec.hidden = true; sec.innerHTML = ''; state.chips = []; }

    var gSel = state.gen ? genByKey(state.gen) : null;
    var chosen = [state.marke, state.modell, gSel ? gSel.codes.join(' / ') : '', state.bj].filter(Boolean).join(' · ');
    var l1 = block1(), l2 = block2();

    $('state').innerHTML = chosen
      ? '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4 4L19 7"/></svg>Ihr Fahrzeug: ' + esc(chosen)
        + ' — ' + (l1.length + l2.length) + ((l1.length + l2.length) === 1 ? ' passende Dashcam' : ' passende Dashcams')
      : '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 16v-5M12 8h.01"/></svg>Wählen Sie Ihr Fahrzeug aus, um die passenden Modelle zu sehen';

    // Block 1
    var b1 = $('block1');
    if (l1.length){
      b1.hidden = false;
      $('b1title').textContent = chosen ? 'Passend für ' + chosen : 'Passend für Ihr Fahrzeug';
      $('b1count').textContent = l1.length + (l1.length === 1 ? ' Produkt' : ' Produkte');
      $('b1grid').innerHTML = l1.map(card).join('');
    } else { b1.hidden = true; $('b1grid').innerHTML = ''; }

    // Block 2
    var b2 = $('block2');
    if (l2.length){
      b2.hidden = false;
      $('b2count').textContent = l2.length + (l2.length === 1 ? ' Produkt' : ' Produkte');
      $('b2grid').innerHTML = l2.map(card).join('');
    } else { b2.hidden = true; $('b2grid').innerHTML = ''; }

    // Kein Treffer / Startzustand
    var em = $('empty'), hint = $('hint');
    if (!state.marke){
      em.hidden = true; em.innerHTML = '';
      hint.hidden = false;
    } else if (!l1.length && !l2.length){
      hint.hidden = true;
      em.hidden = false;
      var subj = encodeURIComponent('FitCamX Anfrage: ' + chosen);
      em.innerHTML = '<div class="fcx-empty"><h3>Kein passendes Modell gefunden</h3>'
        + '<p>Für <strong>' + esc(chosen) + '</strong> haben wir noch keine Variante online. Senden Sie uns Marke, Modell und Baujahr – wir prüfen die Passform und antworten in der Regel am selben Werktag.</p>'
        + '<div class="ecta">'
        + (MAIL ? '<a class="btn btn-primary btn-lg" href="mailto:' + esc(MAIL) + '?subject=' + subj + '">Passform anfragen</a>' : '')
        + '<a class="btn btn-ghost btn-lg" href="' + esc(CONTACT_URL) + '">Zur Beratung</a>'
        + '</div></div>';
    } else {
      em.hidden = true; em.innerHTML = ''; hint.hidden = true;
    }

    syncUrl();
  }

  /* ------------------------ URL-Sync --------------------------- */
  function syncUrl(){
    if (!window.history || !history.replaceState) return;
    var q = [];
    if (state.marke)  q.push('marke='  + encodeURIComponent(state.marke));
    if (state.modell) q.push('modell=' + encodeURIComponent(state.modell));
    if (state.gen)    q.push('gen='    + encodeURIComponent(state.gen));
    if (state.bj)     q.push('bj='     + encodeURIComponent(state.bj));
    var url = location.pathname + (q.length ? '?' + q.join('&') : '');
    try { history.replaceState(null, '', url); } catch(e){}
  }
  function readUrl(){
    var p = new URLSearchParams(location.search);
    state.marke  = p.get('marke')  || '';
    state.modell = p.get('modell') || '';
    state.gen    = p.get('gen')    || '';
    state.bj     = p.get('bj')     || '';
    if (state.gen) state.bj = '';
  }

  /* ------------------------- Events ---------------------------- */
  selM.addEventListener('change', function(e){ state.marke = e.target.value; state.modell=''; state.gen=''; state.bj=''; state.chips=[]; render(); });
  selMo.addEventListener('change', function(e){ state.modell = e.target.value; state.gen=''; state.bj=''; render(); });
  selB.addEventListener('change', function(e){
    var v = e.target.value || '';
    state.gen = v.indexOf('g:') === 0 ? v.slice(2) : '';
    state.bj  = v.indexOf('y:') === 0 ? v.slice(2) : '';
    render();
  });

  ROOT.addEventListener('click', function(ev){
    var r = ev.target.closest('[data-fcx="reset"]');
    if (r){ state.marke=''; state.modell=''; state.gen=''; state.bj=''; state.chips=[]; render(); return; }

    var b = ev.target.closest('[data-brand]');
    if (b){
      var v = b.getAttribute('data-brand');
      state.marke = (state.marke.toLowerCase() === v.toLowerCase()) ? '' : v;
      state.modell=''; state.gen=''; state.bj=''; state.chips=[]; render(); return;
    }

    var c = ev.target.closest('[data-chip]');
    if (c){
      var cv = c.getAttribute('data-chip');
      if (has(state.chips, cv)) state.chips = state.chips.filter(function(x){ return x.toLowerCase() !== cv.toLowerCase(); });
      else state.chips.push(cv);
      render(); return;
    }
  });

  /* -------------------- Daten laden (alle Seiten) --------------- */
  function parseJson(r){
    if (!r.ok) throw new Error('HTTP ' + r.status + ' bei ' + r.url);
    return r.text().then(function(txt){
      var d;
      try { d = JSON.parse(txt); }
      catch(e){ throw new Error('Antwort ist kein JSON - Template collection.fitcamx-data.liquid fehlt im Theme?'); }
      if (!d || !(d.products instanceof Array)) {
        throw new Error('Antwort enthält keine Produktliste - es antwortet die Shopify-JSON-API statt der Vorlage collection.fitcamx-data.liquid.');
      }
      return d;
    });
  }

  function endpoint(page){ return '/collections/' + HANDLE + '?view=fitcamx-data&page=' + page; }

  function load(){
    if (!HANDLE){
      $('loading').textContent = 'Bitte in den Theme-Einstellungen der Section eine Kollektion auswählen.';
      return;
    }
    var cacheKey = 'fcx3:' + HANDLE;
    try {
      var raw = sessionStorage.getItem(cacheKey);
      if (raw){
        var c = JSON.parse(raw);
        if (c && c.ts && (Date.now() - c.ts) < 15*60*1000 && c.products && c.products.length){
          boot(c.products); return;
        }
      }
    } catch(e){}

    fetch(endpoint(1), {headers:{'Accept':'text/html'}})
      .then(parseJson)
      .then(function(d){
        var all = d.products || [];
        var pages = d.pages || 1;
        if (pages <= 1) return all;
        var reqs = [];
        for (var i = 2; i <= pages; i++){
          reqs.push(fetch(endpoint(i), {headers:{'Accept':'text/html'}}).then(parseJson));
        }
        return Promise.all(reqs).then(function(rest){
          rest.forEach(function(x){ all = all.concat(x.products || []); });
          return all;
        });
      })
      .then(function(all){
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ts:Date.now(), products:all})); } catch(e){}
        boot(all);
      })
      .catch(function(err){
        var ld = $('loading');
        ld.hidden = false;
        ld.textContent = 'Die Fahrzeugdaten konnten nicht geladen werden: ' + (err && err.message ? err.message : err);
        if (window.console) console.error('[FitCamX-Finder]', err);
      });
  }

  function boot(list){
    var raw = list || [];
    PRODUCTS = raw.filter(function(p){ return p && p.tg && p.tg.length; });
    if (!PRODUCTS.length){
      var ld = $('loading');
      ld.hidden = false;
      ld.textContent = raw.length
        ? 'Die Kollektion enthält ' + raw.length + ' Produkte, aber keines trägt Tags nach dem Schema marke: / modell: / bj:.'
        : 'Die verknüpfte Kollektion enthält keine Produkte.';
      $('hint').hidden = true;
      return;
    }
    $('loading').hidden = true;
    readUrl();
    // ungueltige Werte aus der URL verwerfen
    if (state.marke && !has(allBrands(), state.marke)) { state.marke=''; state.modell=''; state.gen=''; state.bj=''; }
    if (state.modell && !has(modelOptions(state.marke), state.modell)) { state.modell=''; state.gen=''; state.bj=''; }
    if (state.gen && !genByKey(state.gen)) { state.gen=''; }
    if (state.bj && !has(yearsFor(state.marke, state.modell), state.bj)) { state.bj=''; }
    render();
    if (state.marke){
      var f = ROOT.querySelector('.fcx-finder');
      if (f && location.search) f.scrollIntoView({behavior:'smooth', block:'start'});
    }
  }

  load();
}

function fcxBootAll(){
  var nodes = document.querySelectorAll('.fcx[data-collection]');
  for (var i = 0; i < nodes.length; i++) fcxInit(nodes[i]);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fcxBootAll);
} else {
  fcxBootAll();
}
// Theme-Editor: nach Section-Neuladen erneut initialisieren
document.addEventListener('shopify:section:load', function(e){
  var n = e.target.querySelector ? e.target.querySelector('.fcx[data-collection]') : null;
  if (n) { n.dataset.fcxReady = ''; fcxInit(n); }
});
